import { useState } from 'react';
import { PublicNoticeFilters } from '../types';

interface UseSearchOptions {
    searchFunction: (params: PublicNoticeApiObject) => void;
}

interface PublicNoticeApiObject {
    page_num: number;
    page_count: number;
    search_type: string;
    search_term: string;
    search_radius: string;
    status: 'active' | 'upcoming';
}

const formatApiObj = (search_obj: PublicNoticeFilters): PublicNoticeApiObject => {
    const {
        type: search_type = 'zipcode',
        radius: search_radius = '100',
        term: search_term = '',
        term_state: search_state = '',
        page_num = 1,
        page_count = 15,
        status = 'active',
    } = search_obj;

    const params = {
        page_num,
        page_count,
        search_type,
        search_term: search_type == 'state' ? search_state : search_term,
        search_radius: search_type == 'zipcode' ? search_radius : undefined,
        status,
    };

    return params;
};

export default function useSearch({ searchFunction }: UseSearchOptions) {
    const [filters, setFilters] = useState<PublicNoticeFilters>({
        page_num: 1,
        page_count: 10,
        type: 'zipcode',
        term: '',
        term_state: '',
        term_city: '',
        radius: '100',
        status: 'active',
    });

    const onChangeFilters = (search_obj: PublicNoticeFilters, shouldFire = false) => {
        setFilters(prev => {
            return { ...prev, ...search_obj };
        });

        shouldFire && fireSearch(search_obj);
    };

    const fireSearch = (search_obj: PublicNoticeFilters) => {
        const searchObj = search_obj;
        if (searchObj.type === 'city' && searchObj.term_city) {
            searchObj.term = searchObj.term_city;
        }
        searchFunction(formatApiObj(searchObj));
    };

    return {
        filters,
        onChangeFilters,
    };
}
